var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h3>Информация по контейнеру в пути № {{data.number}}</h3><table class=\"custom_table\"><tbody><tr><td>Номер контейнера</td><td>{{data.number}}</td></tr><tr><td>Номер пломбы</td><td>{{data.seal}}</td></tr><tr><td>Груз</td><td>{{data.cargo}}</td></tr><tr><td>Вес</td><td>{{data.number}}</td></tr><tr><td>Станция отправления</td><td>{{data.station}}</td></tr><tr><td>Место назначения</td><td>{{data.destination}}</td></tr><tr><td>Номер поезда</td><td>{{data.train}}</td></tr><tr><td>Транспорт</td><td>{{data.transport}}</td></tr><tr v-show=\"data.date\"><td>Дата</td><td>{{data.date | parseTime 'humanDate' '.'}}</td></tr></tbody></table>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/train-in-way-info/component.jade
 ** module id = 70
 ** module chunks = 0
 **/